import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'orderBatches';
export const orderBatchesActions = makeActions(
  MODEL_NAME,
  'id',
  'order-batches',
);

export const getAllOrderBatches = orderBatchesActions.getAll;
export const editOrderBatches = orderBatchesActions.edit;
export const createOrderBatches = orderBatchesActions.create;
export const getByIdOrderBatches = orderBatchesActions.getDataById;
